<template>
  <div>
    <span class="sr-only" v-if="accessibilityFeatures">{{ getAriaText(params) }}</span>
    <span class="sr-only" v-if="accessibilityFeatures">{{
      $t('white-label.components.dataQuality.' + ariaLabel)
    }}</span>
    <div v-if="!params.node.group" class="data-quality" :class="type"></div>
  </div>
</template>

<script>
import { getAriaText } from '@utils/helpers';
export default {
  name: 'data-quality-renderer',
  computed: {
    type() {
      return ['R', 'D'].includes(this.params.value) ? this.params.value : '';
    },
    ariaLabel() {
      if (this.type === 'R') return 'realtime';
      else if (this.type === 'D') return 'delayed';
      return 'na';
    },
    accessibilityFeatures() {
      return this.$store.state.applicationSettings.accessibility.settings.accessibilityFeatures;
    }
  },
  methods: {
    getAriaText,
    refresh(params) {
      this.params = params;
      return true;
    }
  }
};
</script>

<style lang="scss" scoped>
.data-quality {
  display: inline-block;
  width: 10px;
  height: 10px;
  border: 1px $gray-100 solid;
  border-radius: 5px;
  background-color: $gray-300;
  transition: all 0.25s ease-in;

  &.R {
    border-color: get-color('green', 'lighten-2');
    background-color: rgba(get-color('green', 'lighten-2', 'rgb'), 0.65);
  }

  &.D {
    border-color: get-color('orange', 'lighten-2');
    background-color: rgba(get-color('orange', 'lighten-2', 'rgb'), 0.65);
  }
}
</style>
